import { render, staticRenderFns } from "./LastCalled.vue?vue&type=template&id=2652c906&"
import script from "./LastCalled.vue?vue&type=script&lang=js&"
export * from "./LastCalled.vue?vue&type=script&lang=js&"
import style0 from "./LastCalled.vue?vue&type=style&index=0&id=2652c906&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports